import i18n from 'i18next';

export const getTranslation = (key: string): string | string[] => {
    const translation = i18n.t(key, { returnObjects: true });
    if (typeof translation === 'string' || Array.isArray(translation)) {
        return translation;
    }
    throw new Error(`Translation for key "${key}" is not a string or an array.`);
};

/** Поддерживаемые локали приложения. */
export type AppLocale = 'ru' | 'en';

/**
 * Аудитория для наборов соцсетей: `'ru'` — русский сайт, `'en'` — любой другой
 * язык (международный набор), как правило бэкенда `App::getLocale() === 'ru'`.
 * Раньше всё не-`en` считалось русским, и на zh-hans, es и остальных языках
 * «Поделиться» показывал VK и MAX без Reddit. Fallback — `'ru'` для
 * Storybook/тестов, где `window.App` не определён (как в `src/i18n.ts`).
 */
export const getAppLocale = (): AppLocale => {
    const baseLang = (window.App?.locale ?? 'ru').split('-')[0].toLowerCase();
    return baseLang === 'ru' ? 'ru' : 'en';
};
